<div class="lane-management-card">
  <div class="card-header">
    <div class="card-header-text">
      <h2 class="card-title">Lane Management</h2>
      <p class="card-description">
        Set up the entry lanes for this location, the camera that watches each one, and how each
        gate opens.
      </p>
    </div>
    <app-add-button buttonText="Add lane" variant="primary" (buttonClick)="onAddLane()">
    </app-add-button>
  </div>

  @if (loading) {
    <div class="loading-container">
      <app-loading-table-shimmer
        [columns]="shimmerColumns"
        [rows]="3"
        [showHeader]="true"
        className="scrollable"
      >
      </app-loading-table-shimmer>
    </div>
  }

  @if (!loading && lanes.length > 0) {
    <div class="table-container">
      <table class="lanes-table">
        <thead>
          <tr>
            <th>Lane Name</th>
            <th>Camera</th>
            <th>Gate</th>
            <th>Type</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (lane of lanes; track lane.id) {
            <tr>
              <td class="lane-name">{{ lane.name }}</td>
              <td>
                <div class="device-cell">
                  @if (lane.cameraSerial) {
                    <span
                      class="connection-dot"
                      [class.connected]="lane.cameraConnected"
                      [class.disconnected]="!lane.cameraConnected"
                      [title]="
                        lane.cameraConnected
                          ? 'Device connected via SSE'
                          : 'Device not connected'
                      "
                      aria-label="Camera connection status"
                    >
                    </span>
                  }
                  <span class="device-text">{{ lane.camera }}</span>
                </div>
              </td>
              <td>
                @if (lane.gate) {
                  <div class="device-cell gate-value">
                    <span
                      class="connection-dot"
                      [class.connected]="lane.gateConnected"
                      [class.disconnected]="!lane.gateConnected"
                      [title]="
                        lane.gateConnected ? 'Device connected via SSE' : 'Device not connected'
                      "
                      aria-label="Gate connection status"
                    >
                    </span>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M4 15V9C4 5.68629 6.68629 3 10 3H14C17.3137 3 20 5.68629 20 9V15"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M2 15H22V21H2V15Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="device-text">{{ lane.gate }}</span>
                  </div>
                } @else {
                  —
                }
              </td>
              <td>
                @if (lane.type) {
                  <span class="type-badge" [class.automatic]="lane.type === 'automatic'">
                    {{ getTypeLabel(lane.type) }}
                  </span>
                } @else {
                  —
                }
              </td>
              <td>
                <span class="status-badge" [class.active]="lane.status === 'active'">
                  {{ getStatusLabel(lane.status) }}
                </span>
              </td>
              <td class="actions-cell">
                <button
                  type="button"
                  class="action-btn"
                  (click)="onEditLane(lane)"
                  aria-label="Edit lane"
                >
                  <img src="/assets/images/edit-icon.svg" alt="" width="18" height="18" />
                </button>
                <button
                  type="button"
                  class="action-btn"
                  (click)="onDeleteLane(lane)"
                  aria-label="Delete lane"
                >
                  <img src="/assets/images/trash.svg" alt="" width="18" height="18" />
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!loading && lanes.length === 0) {
    <div class="empty-state-container">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No lanes configured"
        description="Add an entry lane to get started for this location."
        [actionText]="''"
        [showAction]="false"
      >
      </app-empty-result>
    </div>
  }
</div>

<app-lane-form-modal
  [isOpen]="showLaneFormModal"
  [mode]="laneFormMode"
  [laneId]="editingLaneId"
  [companyOptions]="[]"
  [initialCompanyId]="companyId"
  [initialLocationId]="locationId"
  [lockCompanyLocation]="true"
  (close)="onCloseLaneFormModal()"
  (saved)="onLaneSaved($event)"
>
</app-lane-form-modal>

<app-delete-lane-modal
  [lane]="laneToDelete"
  [isSubmitting]="isDeletingLane"
  (close)="onCloseDeleteLaneModal()"
  (confirm)="onConfirmDeleteLane($event)"
>
</app-delete-lane-modal>
